/**
 * Component for displaying a card to link to an education page
 */
import React from "react";
import { Link } from "react-router-dom";

const EduCard = ({ link, name, desc, external }) => {
  return (
    <Link
      to={`${link}`}
      target={external ? '_blank' : '_self'}
      className="group flex flex-col justify-start items-center border-2 border-light-3 dark:border-dark-2 rounded w-full mx-2 xxs:max-sm:mx-4 sm:h-36 sm:w-[160px] md:w-[270px] md:my-2 mb-2 m-1 md:mx-2"
    >
      <div className="flex h-2 w-full relative bg-cover bg-center">
        <div className="absolute top-0 left-0 h-full w-full bg-gradient-to-r from-red-500 to-blue-500 dark:opacity-50 "></div>
      </div>

      <div className="flex flex-col max-sm:py-3 px-3 items-start justify-start sm:items-center sm:justify-center w-full sm:h-full">
        <span className="flex flex-row items-center justify-center sm:justify-start">
          <h2 className="text-sm md:text-xl sm:mb-2 sm:text-center leading-tight transition-colors duration-300 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5">
            {name}
          </h2>
        </span>
        <p className="md:text-xs text-xxs sm:text-center font-light text-darken pt-2 leading-tight">
          {desc}
        </p>
      </div>
    </Link>
  );
};

export default EduCard;
